<template>
  <div v-if="!loadingObservaciones">
      <template v-for="(observacion, index) in observaciones">
          <observacion
                  :observacion="observacion"
                  :editPath="editPath"
                  :editable="observacion.editable"
                  :key="index">
          </observacion>
      </template>
    <ObservacionNew :dialogRechazo="observacionDialog" @cerrarModal="cerrarModal" :id="id" ref="observacionNew" :hideSubmit="hideSubmit"
    @observacionCreada="cerrarYUpdate" :createPath="createPath" :payloadId="payloadId" v-if="canEdit && canAdd">
    </ObservacionNew>
  </div>
</template>

<script>
import Observacion from './Observacion.vue'
import ObservacionNew from './ObservacionNew.vue'

export default {
  components: {
    Observacion,
    ObservacionNew
  },
  props: {
    canAdd: {
      type: Boolean,
      default: true
    },
    listPath: String,
    createPath: String,
    editPath: String,
    canEdit: Boolean,
    hideSubmit: {
      type: Boolean,
      default: false
    },
    payloadId: String,
    id: [String, Number]
  },

  data () {
    return {
      editable: true,
      editing: false,
      observacionDialog: false,
      loadingObservaciones: true,
      observaciones: []
    }
  },

  methods: {
    agregarObservacion () {
      this.$refs.observacionNew.createObservacion()
    },
    createObservacion () {
      this.observacionDialog = true
    },
    cerrarYUpdate () {
      this.observacionDialog = false
      this.fetchObservaciones()
      this.$emit('observacionCreada')
    },
    cerrarModal () {
      this.observacionDialog = false
    },
    fetchObservaciones () {
      this.axios
        .get(this.listPath)
        .then(response => {
          this.observaciones = response.data
          this.loadingObservaciones = false
        })
        .catch(error => {
          this.$store.commit('setErrorMsg', error)
          this.loadingObservaciones = false
        })
    }
  },
  computed: {
    tieneObservacionesSinGuardar () {
      if (this.$refs.observacionNew) {
        return this.$refs.observacionNew.observacionSinGuardar
      }
      return false
    },
    isEditing () {
      return this.id != null
    }
  },
  created () {
    this.loadingObservaciones = true
    this.fetchObservaciones()
  }
}
</script>

<style scoped>
    .observation-area {
        background-color: #e9eaec;
        margin-top: 1em;
    }
</style>
